import React, { useEffect, lazy, createElement } from 'react';
import { CheckIcon, StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon, FlameIcon, XIcon } from 'lucide-react';
export function SalesPage() {
  useEffect(() => {
    // 1. Preconnect to Google Fonts domains
    const preconnects = [{
      href: 'https://fonts.googleapis.com',
      crossOrigin: false
    }, {
      href: 'https://fonts.gstatic.com',
      crossOrigin: true
    }];
    preconnects.forEach(({
      href,
      crossOrigin
    }) => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      if (crossOrigin) {
        link.crossOrigin = 'anonymous';
      }
      document.head.appendChild(link);
    });
    // 2. Preload hero mockup image
    const mockupPreload = document.createElement('link');
    mockupPreload.rel = 'preload';
    mockupPreload.as = 'image';
    mockupPreload.href = 'https://cdn.magicpatterns.com/uploads/fKLH2ZsKrmrGuJkDyF8Ef6/mockup_webp_(1)_(1).webp';
    mockupPreload.setAttribute('fetchpriority', 'high');
    document.head.insertBefore(mockupPreload, document.head.firstChild);
    // 3. Non-blocking Google Fonts loading
    const fontPreload = document.createElement('link');
    fontPreload.rel = 'preload';
    fontPreload.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap';
    fontPreload.as = 'style';
    fontPreload.onload = function () {
      this.onload = null;
      this.rel = 'stylesheet';
    };
    document.head.appendChild(fontPreload);
    // Noscript fallback for fonts
    const noscript = document.createElement('noscript');
    const fontFallback = document.createElement('link');
    fontFallback.rel = 'stylesheet';
    fontFallback.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap';
    noscript.appendChild(fontFallback);
    document.head.appendChild(noscript);
    // 4. Defer Facebook Pixel loading by 4 seconds after page load
    window.addEventListener('load', function () {
      setTimeout(() => {
        const w = window as any;
        if (w.fbq) return;
        const n = w.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [] as any[];
        const script = document.createElement('script');
        script.defer = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.body.appendChild(script);
        w.fbq('init', '1688179945683486');
        w.fbq('track', 'PageView');
      }, 4000);
    });
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-2">
      {/* Meta Pixel noscript */}
      <noscript data-id="element-3">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1688179945683486&ev=PageView&noscript=1" alt="" data-id="element-4" />
      </noscript>

      {/* Attention Banner */}
      <div className="bg-gradient-to-r from-[#F5821F] to-orange-600 py-3 px-4" data-id="element-5">
        <div className="max-w-6xl mx-auto" data-id="element-6">
          <p className="text-center text-sm md:text-base font-semibold text-white" data-id="element-7">
            🍗 ATENCIÓN: PERSONAS QUE BUSCAN BAJAR DE PESO, SIN DIETA ESTRICTA.
          </p>
        </div>
      </div>

      <main data-id="element-8">
        {/* Hero Section */}
        <section className="max-w-6xl mx-auto px-4 py-8 md:py-12" data-id="element-9">
          <h1 className="md:text-6xl lg:text-7xl font-bold text-center mb-6 text-[#1A1A1A] text-[48px]" data-id="element-10">
            Sin plan no hay resultado. Nunca. <br data-id="element-11" />
            <span className="text-[#4CAF72]" data-id="element-12">
              Adelgaza con Air fryer es ese plan.
            </span>
          </h1>

          <div className="max-w-4xl mx-auto mb-6" data-id="element-13">
            <img src="https://cdn.magicpatterns.com/uploads/fKLH2ZsKrmrGuJkDyF8Ef6/mockup_webp_(1)_(1).webp" alt="MegaPack Adelgaza con Air Fryer" width="600" height="500" fetchPriority="high" loading="eager" className="w-full rounded-2xl shadow-xl" data-id="element-14" />
          </div>

          <div className="max-w-3xl mx-auto mb-8" data-id="element-15">
            <div className="bg-[#F0FAF4] border-l-4 border-[#4CAF72] p-6 rounded-r-lg" data-id="element-16">
              <p className="text-lg md:text-xl leading-relaxed text-[#333333]" data-id="element-17">
                El único sistema{' '}
                <span className="text-[#F5821F] font-semibold" data-id="element-18">
                  "Abrir y Cocinar"
                </span>{' '}
                que transforma tu freidora de aire en una máquina de quemar
                grasa. Sin pasar hambre, sin contar calorías y sin efecto
                rebote.
              </p>
            </div>
          </div>

          <div className="text-center mb-6" data-id="element-19">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#4CAF72]" data-id="element-20">
              MEGAPACK ADELGAZA CON AIR FRYER™
            </h2>
            <div className="flex items-center justify-center gap-2 mb-3" data-id="element-21">
              <div className="flex" data-id="element-22">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-6 h-6 fill-[#F5821F] text-[#F5821F]" data-id="element-23" />)}
              </div>
              <span className="text-lg text-[#333333]" data-id="element-24">
                4,9/5 (+1.200 Verificados)
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 text-[#F5821F] font-semibold mb-6" data-id="element-25">
              <FlameIcon className="w-5 h-5" data-id="element-26" />
              <span data-id="element-27">24 personas compraron hoy</span>
            </div>

            <a href="#pricing" className="inline-block bg-[#F5821F] hover:bg-orange-600 text-white font-bold text-lg px-12 py-5 rounded-full shadow-lg transform hover:scale-105 transition-all duration-200 mb-4" data-id="element-28">
              🚀 ¡SÍ! QUIERO ADELGAZAR HOY
            </a>

            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-[#333333]" data-id="element-29">
              <div className="flex items-center gap-2" data-id="element-30">
                <ZapIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-31" />
                <span data-id="element-32">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-33">
                <ShieldCheckIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-34" />
                <span data-id="element-35">Garantía 7 Días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-36">
                <CreditCardIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-37" />
                <span data-id="element-38">Pago Único</span>
              </div>
            </div>
          </div>

          <div className="bg-[#F0FAF4] border border-[#E8F5ED] rounded-lg p-4 max-w-2xl mx-auto text-center" data-id="element-39">
            <p className="text-sm md:text-base text-[#333333]" data-id="element-40">
              🇪🇸 Diseñado para España — Mercadona, Lidl y Aldi. Sin ingredientes
              raros.
            </p>
          </div>
        </section>

        {/* Problem Statement */}
        <section className="bg-[#F9F9F9] py-8" data-id="element-41">
          <div className="max-w-6xl mx-auto px-4" data-id="element-42">
            <div className="bg-white rounded-2xl p-8 md:p-12 border border-[#E8F5ED] shadow-sm" data-id="element-43">
              <p className="text-xl md:text-2xl text-center leading-relaxed text-[#333333]" data-id="element-44">
                El 95% de las personas que hacen dieta recuperan el peso en
                menos de un año.
                <span className="text-[#4CAF72] font-semibold" data-id="element-45">
                  {' '}
                  El problema no es tu voluntad.
                </span>{' '}
                Es que nadie te dio el sistema correcto.
              </p>
            </div>
          </div>
        </section>

        {/* Food Photos Section */}
        <section className="bg-white py-8" data-id="element-46">
          <div className="max-w-6xl mx-auto px-4" data-id="element-47">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 text-[#1A1A1A]" data-id="element-48">
              🍗 ESTO ES LO QUE VAS A COCINAR ESTA SEMANA
            </h2>
            <p className="text-xl text-center text-[#4CAF72] font-semibold mb-8" data-id="element-49">
              Crujiente. Sabroso. Listo en menos de 20 minutos.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-50">
              <div className="text-center" data-id="element-51">
                <div className="rounded-xl overflow-hidden shadow-lg mb-3" data-id="element-52">
                  <img src="https://cdn.magicpatterns.com/uploads/im76ixtbRr1Lk139WobvmM/ChatGPT_Image_5_may_2026,_11_41_05_(1).webp" alt="Pollo crujiente con ajo y limón" width="400" height="300" loading="lazy" className="w-full h-[300px] object-cover" data-id="element-53" />
                </div>
                <p className="text-[#4CAF72] font-semibold" data-id="element-54">
                  Pollo crujiente con ajo y limón — ⏱ 18 min
                </p>
              </div>

              <div className="text-center" data-id="element-55">
                <div className="rounded-xl overflow-hidden shadow-lg mb-3" data-id="element-56">
                  <img src="https://cdn.magicpatterns.com/uploads/ww6FwfjeQCXtMRccfxUs4X/ChatGPT_Image_5_may_2026,_11_41_03_(1).webp" alt="Salmón dorado con espárragos" width="400" height="300" loading="lazy" className="w-full h-[300px] object-cover" data-id="element-57" />
                </div>
                <p className="text-[#4CAF72] font-semibold" data-id="element-58">
                  Salmón dorado con espárragos — ⏱ 15 min
                </p>
              </div>

              <div className="text-center" data-id="element-59">
                <div className="rounded-xl overflow-hidden shadow-lg mb-3" data-id="element-60">
                  <img src="https://cdn.magicpatterns.com/uploads/grjbUfFxiWfGCg5gLAP5aG/ChatGPT_Image_5_may_2026,_11_40_58_(1).webp" alt="Verduras asadas con ñoquis y aceite de oliva" width="400" height="300" loading="lazy" className="w-full h-[300px] object-cover" data-id="element-61" />
                </div>
                <p className="text-[#4CAF72] font-semibold" data-id="element-62">
                  Verduras asadas con ñoquis y aceite de oliva — ⏱ 12 min
                </p>
              </div>
            </div>

            <p className="text-center text-xl text-[#333333] max-w-3xl mx-auto" data-id="element-63">
              Comida real. Resultados reales. Con la freidora que ya tienes en
              casa. Y tú ¿qué esperas para obtener estas recetas?
            </p>
          </div>
        </section>

        {/* Comparison Table */}
        <section className="max-w-6xl mx-auto px-4 py-8" data-id="element-64">
          <div className="overflow-x-auto" data-id="element-65">
            <table className="w-full bg-white rounded-2xl overflow-hidden border border-[#E8F5ED] shadow-sm" data-id="element-66">
              <thead data-id="element-67">
                <tr className="bg-[#F9F9F9]" data-id="element-68">
                  <th className="px-6 py-4 text-left text-lg font-bold text-[#E53935]" data-id="element-69">
                    SIN EL MEGAPACK
                  </th>
                  <th className="px-6 py-4 text-left text-lg font-bold text-[#4CAF72]" data-id="element-70">
                    CON EL MEGAPACK
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#E8F5ED]" data-id="element-71">
                <tr data-id="element-72">
                  <td className="px-6 py-4 text-[#595959]" data-id="element-73">
                    <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-74" />
                    Pollo hervido y ensalada — otra vez
                  </td>
                  <td className="px-6 py-4 text-[#333333]" data-id="element-75">
                    <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-76" />
                    Recetas crujientes listas en 15 minutos
                  </td>
                </tr>
                <tr data-id="element-77">
                  <td className="px-6 py-4 text-[#595959]" data-id="element-78">
                    <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-79" />
                    Dieta abandonada el jueves
                  </td>
                  <td className="px-6 py-4 text-[#333333]" data-id="element-80">
                    <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-81" />
                    Un plan que puedes mantener sin sufrimiento
                  </td>
                </tr>
                <tr data-id="element-82">
                  <td className="px-6 py-4 text-[#595959]" data-id="element-83">
                    <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-84" />
                    Air Fryer cogiendo polvo
                  </td>
                  <td className="px-6 py-4 text-[#333333]" data-id="element-85">
                    <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-86" />
                    Tu freidora trabajando para ti cada día
                  </td>
                </tr>
                <tr data-id="element-87">
                  <td className="px-6 py-4 text-[#595959]" data-id="element-88">
                    <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-89" />
                    Antojo nocturno que arruina todo
                  </td>
                  <td className="px-6 py-4 text-[#333333]" data-id="element-90">
                    <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-91" />
                    Postres saludables que frenan el antojo
                  </td>
                </tr>
                <tr data-id="element-92">
                  <td className="px-6 py-4 text-[#595959]" data-id="element-93">
                    <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-94" />
                    Efecto rebote garantizado
                  </td>
                  <td className="px-6 py-4 text-[#333333]" data-id="element-95">
                    <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-96" />
                    Sistema de mantenimiento incluido
                  </td>
                </tr>
                <tr data-id="element-97">
                  <td className="px-6 py-4 text-[#595959]" data-id="element-98">
                    <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-99" />
                    Lunes empezando de cero siempre
                  </td>
                  <td className="px-6 py-4 text-[#333333]" data-id="element-100">
                    <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-101" />
                    Resultados que se mantienen de verdad
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* For You If */}
        <section className="bg-[#F9F9F9] py-8" data-id="element-102">
          <div className="max-w-6xl mx-auto px-4" data-id="element-103">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#4CAF72]" data-id="element-104">
              Este sistema es para ti si…
            </h2>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-105">
              {['Tienes Air Fryer en casa pero no sabes cómo usarla para adelgazar de verdad', 'Empiezas dietas con fuerza y las abandonas antes del fin de semana', 'Estás harta de comer aburrido mientras el resto de la familia come bien', 'Quieres perder peso sin pastillas, sin batidos y sin pasar hambre'].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white p-6 rounded-xl border border-[#E8F5ED] shadow-sm" data-id="element-106">
                  <CheckIcon className="w-6 h-6 text-[#4CAF72] flex-shrink-0 mt-1" data-id="element-107" />
                  <p className="text-lg text-[#333333]" data-id="element-108">{item}</p>
                </div>)}
            </div>
          </div>
        </section>

        {/* What's Included */}
        <section className="max-w-6xl mx-auto px-4 py-8" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 text-[#4CAF72]" data-id="element-110">
            ¿Qué incluye el MegaPack?
          </h2>
          <p className="text-xl text-center text-[#595959] mb-8" data-id="element-111">
            6 libros PDF listos para usar desde hoy mismo
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-112">
            {[{
            icon: '📗',
            title: 'LIBRO 1 — Cómo Adelgazar con Air Fryer',
            description: 'La base del sistema. Qué comer, qué evitar y por qué funciona cuando todo lo demás ha fallado.'
          }, {
            icon: '📙',
            title: 'LIBRO 2 — Recetas del Día a Día',
            description: '+50 recetas en menos de 20 minutos. Pollo crujiente, salmón, aperitivos. Comida real que te apetece comer.'
          }, {
            icon: '📘',
            title: 'LIBRO 3 — Planifica tus Comidas',
            description: 'Nunca más improvises. Abre el libro, sigue el plan. Tan simple como eso.'
          }, {
            icon: '📕',
            title: 'LIBRO 4 — Batch Cooking con Air Fryer',
            description: 'Cocina una vez. Come sano toda la semana. Ahorra tiempo y energía.'
          }, {
            icon: '📓',
            title: 'LIBRO 5 — Postres sin Culpa',
            description: 'El antojo resuelto de una vez. Postres y snacks saludables para las noches difíciles.'
          }, {
            icon: '📔',
            title: 'LIBRO 6 — Sin Efecto Rebote',
            description: 'El sistema para mantener los resultados de por vida. Sin volver al punto de partida.'
          }].map((book, index) => <div key={index} className="bg-white p-6 rounded-xl border border-[#E8F5ED] hover:border-[#4CAF72] transition-colors shadow-sm" data-id="element-113">
                <div className="text-4xl mb-4" data-id="element-114">{book.icon}</div>
                <h3 className="text-lg font-bold mb-3 text-[#F5821F]" data-id="element-115">
                  {book.title}
                </h3>
                <p className="text-[#666666]" data-id="element-116">{book.description}</p>
              </div>)}
          </div>
        </section>

        {/* Preview Images */}
        <section className="bg-[#F9F9F9] py-8" data-id="element-117">
          <div className="max-w-6xl mx-auto px-4" data-id="element-118">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 text-[#4CAF72]" data-id="element-119">
              📸 MIRA EL MATERIAL POR DENTRO
            </h2>
            <p className="text-xl text-center text-[#666666] mb-8" data-id="element-120">
              Esto es exactamente lo que recibes hoy
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-121">
              {['https://cdn.magicpatterns.com/uploads/eA3b75jfzvzVvCP9vUsjMp/WhatsApp_Image_2026-05-04_at_19.16.33_(3).webp', 'https://cdn.magicpatterns.com/uploads/aBbXLkLqb9QDi5Fgktua1Q/WhatsApp_Image_2026-05-04_at_19.16.33_(2).webp', 'https://cdn.magicpatterns.com/uploads/6c6P6dgRtd9WbYzaJXPJpA/WhatsApp_Image_2026-05-04_at_19.16.32_(2).webp', 'https://cdn.magicpatterns.com/uploads/a6xfNeLZ3hHiGmhvVVYP27/WhatsApp_Image_2026-05-04_at_19.16.32_(1).webp'].map((img, index) => <div key={index} className="rounded-xl overflow-hidden shadow-lg border border-[#E8F5ED]" data-id="element-122">
                  <img src={img} alt={`Preview ${index + 1}`} width="380" height="280" loading="lazy" className="w-full h-auto" data-id="element-123" />
                </div>)}
            </div>

            <p className="text-center text-xl text-[#333333]" data-id="element-124">
              No compras a ciegas. Sabes exactamente lo que recibes.
            </p>
          </div>
        </section>

        {/* Bonuses */}
        <section className="max-w-6xl mx-auto px-4 py-8" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 text-[#4CAF72]" data-id="element-126">
            6 Bonos Estratégicos Incluidos
          </h2>
          <p className="text-xl text-center text-[#666666] mb-8" data-id="element-127">
            Sin coste extra — Valor total: 22,00€
          </p>

          <div className="space-y-6" data-id="element-128">
            {[{
            icon: '🎁',
            title: 'Plan Semanal Completo',
            description: 'Tu semana resuelta de domingo a domingo. Sin improvisar. Sin Glovo.',
            badge: 'GRATIS'
          }, {
            icon: '🎁',
            title: 'Guía de Cocción Air Fryer',
            description: 'Temperaturas y tiempos exactos para cada alimento. Nunca más carne seca.',
            badge: 'GRATIS'
          }, {
            icon: '🎁',
            title: 'Lista de la Compra Mensual',
            description: 'Entra al Mercadona con un plan. Sal en 20 minutos.',
            badge: 'GRATIS'
          }].map((bonus, index) => <div key={index} className="bg-white p-6 rounded-xl border border-[#E8F5ED] flex items-start gap-4 shadow-sm" data-id="element-129">
                <div className="text-4xl" data-id="element-130">{bonus.icon}</div>
                <div className="flex-1" data-id="element-131">
                  <h3 className="text-xl font-bold mb-2 text-[#1A1A1A]" data-id="element-132">
                    {bonus.title}
                  </h3>
                  <p className="text-[#666666]" data-id="element-133">{bonus.description}</p>
                </div>
                <span className="bg-[#4CAF72] text-white px-4 py-1 rounded-full text-sm font-bold whitespace-nowrap" data-id="element-134">
                  {bonus.badge}
                </span>
              </div>)}
          </div>
        </section>

        {/* Pricing */}
        <section id="pricing" className="bg-[#F9F9F9] py-8" data-id="element-135">
          <div className="max-w-6xl mx-auto px-4" data-id="element-136">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#4CAF72]" data-id="element-137">
              La Oferta
            </h2>

            <div className="bg-white rounded-2xl p-8 mb-8 border border-[#E8F5ED] shadow-sm" data-id="element-138">
              <h3 className="text-2xl font-bold mb-6 text-center text-[#1A1A1A]" data-id="element-139">
                TODO ESTO POR SEPARADO:
              </h3>
              <div className="overflow-x-auto" data-id="element-140">
                <table className="w-full" data-id="element-141">
                  <tbody className="divide-y divide-[#E8F5ED]" data-id="element-142">
                    <tr data-id="element-143">
                      <td className="py-3 text-lg text-[#333333]" data-id="element-144">
                        MegaPack (6 Libros)
                      </td>
                      <td className="py-3 text-right text-xl font-bold text-[#1A1A1A]" data-id="element-145">
                        49,00€
                      </td>
                    </tr>
                    <tr data-id="element-146">
                      <td className="py-3 text-lg text-[#333333]" data-id="element-147">
                        Sistema AIR‑FAST 7
                      </td>
                      <td className="py-3 text-right text-xl font-bold text-[#1A1A1A]" data-id="element-148">
                        29,00€
                      </td>
                    </tr>
                    <tr data-id="element-149">
                      <td className="py-3 text-lg text-[#333333]" data-id="element-150">
                        3 Bonos Estratégicos
                      </td>
                      <td className="py-3 text-right text-xl font-bold text-[#1A1A1A]" data-id="element-151">
                        22,00€
                      </td>
                    </tr>
                    <tr className="border-t-2 border-[#4CAF72]" data-id="element-152">
                      <td className="py-3 text-xl font-bold text-[#1A1A1A]" data-id="element-153">
                        TOTAL
                      </td>
                      <td className="py-3 text-right text-2xl font-bold text-[#4CAF72]" data-id="element-154">
                        100,00€
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-155">
              {/* Base Package */}
              <div className="bg-white rounded-2xl p-8 border-2 border-[#E8F5ED] hover:border-[#4CAF72] transition-colors shadow-sm" data-id="element-156">
                <div className="text-center mb-6" data-id="element-157">
                  <h3 className="text-2xl font-bold mb-2 text-[#1A1A1A]" data-id="element-158">
                    📘 MEGAPACK BASE
                  </h3>
                  <p className="text-[#595959] mb-4" data-id="element-159">6 Libros + 3 Bonos</p>
                  <div className="flex items-center justify-center gap-4 mb-4" data-id="element-160">
                    <span className="text-3xl text-[#F5821F] line-through" data-id="element-161">
                      49,00€
                    </span>
                    <span className="text-5xl font-bold text-[#4CAF72]" data-id="element-162">
                      13,99€
                    </span>
                  </div>
                </div>
                <a href="https://pagos.digipromarket.com/cart/56222402937158:1" className="block w-full bg-[#F5821F] hover:bg-orange-600 text-white font-bold text-lg py-4 rounded-full text-center transition-colors" data-id="element-163">
                  🟠 → QUIERO EL MEGAPACK BASE
                </a>
              </div>

              {/* Total Package */}
              <div className="bg-gradient-to-br from-[#F0FAF4] to-white rounded-2xl p-8 border-2 border-[#F5821F] relative shadow-lg" data-id="element-164">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-165">
                  <span className="bg-[#F5821F] text-white px-6 py-2 rounded-full text-sm font-bold" data-id="element-166">
                    La más elegida
                  </span>
                </div>
                <div className="text-center mb-6 mt-4" data-id="element-167">
                  <h3 className="text-2xl font-bold mb-2 text-[#1A1A1A]" data-id="element-168">
                    🏆 MEGAPACK TOTAL + AIR‑FAST 7 ⭐
                  </h3>
                  <p className="text-[#666666] mb-2" data-id="element-169">
                    6 Libros + 3 Bonos + Sistema AIR‑FAST 7 de 21 días
                  </p>
                  <p className="text-sm text-[#4CAF72] mb-4" data-id="element-170">
                    Por solo 6€ más, resultados desde el primer mes
                  </p>
                  <div className="flex items-center justify-center gap-4 mb-4" data-id="element-171">
                    <span className="text-3xl text-[#F5821F] line-through" data-id="element-172">
                      78,00€
                    </span>
                    <span className="text-5xl font-bold text-[#4CAF72]" data-id="element-173">
                      19,99€
                    </span>
                  </div>
                </div>
                <a href="https://pagos.digipromarket.com/cart/56222886723910:1" className="block w-full bg-[#F5821F] hover:bg-orange-600 text-white font-bold text-xl py-5 rounded-full text-center transition-all transform hover:scale-105 shadow-lg" data-id="element-174">
                  🟠 → QUIERO EL MEGAPACK TOTAL + AIR‑FAST 7 ⭐
                </a>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-[#333333]" data-id="element-175">
              <div className="flex items-center gap-2" data-id="element-176">
                <ZapIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-177" />
                <span data-id="element-178">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-179">
                <CreditCardIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-180" />
                <span data-id="element-181">Pago Único</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-182">
                <ShieldCheckIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-183" />
                <span data-id="element-184">Garantía 7 Días</span>
              </div>
            </div>
          </div>
        </section>

        {/* Guarantee */}
        <section className="max-w-6xl mx-auto px-4 py-8" data-id="element-185">
          <div className="bg-[#F0FAF4] rounded-2xl p-8 md:p-12 border-2 border-[#4CAF72]" data-id="element-186">
            <div className="flex items-start gap-6" data-id="element-187">
              <ShieldCheckIcon className="w-16 h-16 text-[#4CAF72] flex-shrink-0" data-id="element-188" />
              <div data-id="element-189">
                <h2 className="text-3xl font-bold mb-4 text-[#1A1A1A]" data-id="element-190">
                  🛡️ ADELGAZAS O TE DEVOLVEMOS EL DINERO
                </h2>
                <p className="text-lg text-[#333333] mb-4" data-id="element-191">
                  Estamos tan seguros de que este sistema funciona que te damos
                  7 días para probarlo en tu cocina. Si no es exactamente lo que
                  esperabas — te devolvemos el 100%. Sin formularios. Sin
                  preguntas. Sin drama.
                </p>
                <p className="text-[#4CAF72] font-semibold" data-id="element-192">
                  Tasa de devoluciones: menos del 1%.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="bg-[#F9F9F9] py-8" data-id="element-193">
          <div className="max-w-6xl mx-auto px-4" data-id="element-194">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#4CAF72]" data-id="element-195">
              ❤️ Lo que dicen los que ya lo tienen:
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-196">
              {[{
              result: 'Perdí 4 kilos en 5 semanas',
              name: 'María G.',
              location: 'Madrid',
              rating: 5,
              text: 'Mi familia come lo mismo que yo y no saben que estoy a dieta. Nunca pensé que adelgazar pudiera ser tan fácil.'
            }, {
              result: '3,5 kilos en 6 semanas sin pasar hambre',
              name: 'Laura P.',
              location: 'Barcelona',
              rating: 5,
              text: 'El plan semanal eliminó el picar entre horas. Mis compañeras me preguntan qué estoy haciendo.'
            }, {
              result: '4 meses sin subir ni un gramo',
              name: 'Roberto M.',
              location: 'Valencia',
              rating: 5,
              text: 'Siempre recuperaba el peso. El libro Sin Efecto Rebote cambió todo. Por fin entendí por qué fallaba siempre.'
            }, {
              result: '5 kilos en 7 semanas cocinando para toda la familia',
              name: 'Ana T.',
              location: 'Zaragoza',
              rating: 5,
              text: 'Mis hijos piden el pollo crujiente cada semana. No saben que estoy a dieta.'
            }, {
              result: 'Me ahorro más de 80€ al mes en delivery',
              name: 'David S.',
              location: 'Madrid',
              rating: 5,
              text: '6 kilos en 8 semanas. El pack se paga solo la primera semana.'
            }, {
              result: 'El AIR‑FAST 7 fue la mejor decisión que tomé',
              name: 'Patricia L.',
              location: 'Málaga',
              rating: 5,
              text: 'Los 21 días iniciales me dieron el impulso que nunca tuve con ninguna dieta. Llevo 3 meses y no paro.'
            }].map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-xl border border-[#E8F5ED] shadow-sm" data-id="element-197">
                  <div className="mb-3" data-id="element-198">
                    <p className="text-lg font-bold text-[#4CAF72] mb-2" data-id="element-199">
                      📉 "{testimonial.result}"
                    </p>
                    <div className="flex mb-2" data-id="element-200">
                      {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#F5821F] text-[#F5821F]" data-id="element-201" />)}
                    </div>
                  </div>
                  <p className="text-[#333333] mb-4" data-id="element-202">"{testimonial.text}"</p>
                  <p className="font-semibold text-[#1A1A1A]" data-id="element-203">
                    {testimonial.name} | {testimonial.location}
                  </p>
                  <p className="text-sm text-[#4CAF72] flex items-center gap-1 mt-2" data-id="element-204">
                    <CheckIcon className="w-4 h-4" data-id="element-205" />
                    Compra verificada
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* CTA After Testimonials */}
        <section className="max-w-6xl mx-auto px-4 py-8" data-id="element-206">
          <div className="bg-gradient-to-br from-[#F0FAF4] to-white rounded-2xl p-8 md:p-12 text-center border-2 border-[#4CAF72] shadow-lg" data-id="element-207">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#4CAF72]" data-id="element-208">
              🚀 ¡SÍ! QUIERO ADELGAZAR CON MI AIR FRYER
            </h2>
            <p className="text-lg text-[#333333] mb-6" data-id="element-209">
              Más de 1.200 personas ya dentro. El precio de lanzamiento no dura
              para siempre.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-[#333333] mb-6" data-id="element-210">
              <div className="flex items-center gap-2" data-id="element-211">
                <ZapIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-212" />
                <span data-id="element-213">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-214">
                <ShieldCheckIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-215" />
                <span data-id="element-216">Garantía 7 Días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-217">
                <CreditCardIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-218" />
                <span data-id="element-219">Pago Único</span>
              </div>
            </div>
            <a href="#pricing" className="inline-block bg-[#F5821F] hover:bg-orange-600 text-white font-bold text-xl px-12 py-5 rounded-full shadow-lg transform hover:scale-105 transition-all duration-200" data-id="element-220">
              VER OFERTAS
            </a>
          </div>
        </section>

        {/* FAQ */}
        <section className="max-w-4xl mx-auto px-4 py-8" data-id="element-221">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#4CAF72]" data-id="element-222">
            ❓ Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-223">
            {[{
            q: '¿Cómo recibo el MegaPack?',
            a: 'Email con acceso inmediato. En menos de 5 minutos en tu móvil, tablet u ordenador. Sin apps adicionales.'
          }, {
            q: '¿Necesito una Air Fryer específica?',
            a: 'No. Funciona con cualquier marca y modelo del mercado. La Guía de Cocción incluida se adapta a todos.'
          }, {
            q: '¿Tengo que contar calorías?',
            a: 'No. El sistema ya está equilibrado. Solo abre el plan, cocina y come. Nada más.'
          }, {
            q: '¿Funciona si tengo muy poco tiempo?',
            a: 'Especialmente diseñado para eso. Ninguna receta supera los 20 minutos. El Batch Cooking resuelve toda la semana en una tarde del domingo.'
          }, {
            q: '¿Puedo seguirlo si soy vegetariano o tengo intolerancia al gluten?',
            a: 'Sí. Los 6 libros incluyen variantes para diferentes necesidades. Muchas recetas son naturalmente sin gluten.'
          }, {
            q: '¿Tiene garantía real?',
            a: '7 días completos. Devolución del 100% sin formularios, sin preguntas y sin drama. Tasa de devoluciones menor al 1%.'
          }].map((faq, index) => <details key={index} className="bg-white rounded-xl border border-[#E8F5ED] overflow-hidden shadow-sm" data-id="element-224">
                <summary className="px-6 py-4 cursor-pointer font-semibold text-lg hover:bg-[#F9F9F9] transition-colors text-[#1A1A1A]" data-id="element-225">
                  {faq.q}
                </summary>
                <div className="px-6 pb-4 text-[#666666]" data-id="element-226">{faq.a}</div>
              </details>)}
          </div>
        </section>

        {/* Final CTA */}
        <section className="bg-[#F0FAF4] py-8" data-id="element-227">
          <div className="max-w-6xl mx-auto px-4" data-id="element-228">
            <div className="bg-white rounded-2xl p-8 md:p-12 text-center border-2 border-[#4CAF72] shadow-lg" data-id="element-229">
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#1A1A1A]" data-id="element-230">
                Mañana abrirás la nevera.
              </h2>
              <p className="text-xl mb-8 text-[#333333]" data-id="element-231">
                La pregunta es qué va a pasar.
              </p>

              <div className="grid md:grid-cols-2 gap-8 mb-10 text-left" data-id="element-232">
                <div className="bg-red-50 border-l-4 border-[#E53935] p-6 rounded-r-lg" data-id="element-233">
                  <h3 className="text-xl font-bold mb-3 text-[#E53935]" data-id="element-234">
                    Opción A
                  </h3>
                  <p className="text-[#595959]" data-id="element-235">
                    Improvisas otra vez. Comes lo que encuentres. Llegas a la
                    noche con culpa. El lunes vuelves a empezar de cero.
                  </p>
                </div>

                <div className="bg-[#F0FAF4] border-l-4 border-[#4CAF72] p-6 rounded-r-lg" data-id="element-236">
                  <h3 className="text-xl font-bold mb-3 text-[#4CAF72]" data-id="element-237">
                    Opción B
                  </h3>
                  <p className="text-[#595959]" data-id="element-238">
                    Abres el plan. Sabes exactamente qué cocinar. Tu Air Fryer
                    hace el trabajo. Terminas el día sin culpa por primera vez
                    en mucho tiempo.
                  </p>
                </div>
              </div>

              <p className="text-xl mb-8 text-[#333333] italic" data-id="element-239">
                La Air Fryer ya la tienes. El sistema lo tienes aquí. La
                decisión es tuya.
              </p>

              <a href="#pricing" className="inline-block bg-[#F5821F] hover:bg-orange-600 text-white font-bold text-xl px-12 py-5 rounded-full shadow-lg transform hover:scale-105 transition-all duration-200 mb-6" data-id="element-240">
                🚀 ¡SÍ! QUIERO ADELGAZAR CON MI AIR FRYER
              </a>

              <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-[#333333]" data-id="element-241">
                <div className="flex items-center gap-2" data-id="element-242">
                  <ZapIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-243" />
                  <span data-id="element-244">Acceso Inmediato</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-245">
                  <ShieldCheckIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-246" />
                  <span data-id="element-247">Garantía 7 Días</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-248">
                  <CreditCardIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-249" />
                  <span data-id="element-250">Tarjeta o PayPal</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#F9F9F9] border-t border-[#E8F5ED] py-8" data-id="element-251">
        <div className="max-w-6xl mx-auto px-4" data-id="element-252">
          <div className="text-center mb-6" data-id="element-253">
            <h3 className="text-2xl font-bold mb-2 text-[#4CAF72]" data-id="element-254">
              🍗 ADELGAZA CON AIR FRYER™
            </h3>
            <p className="text-[#595959] mb-4" data-id="element-255">
              Porque adelgazar no debería costarte todos los lunes del año.
            </p>
            <div className="flex items-center justify-center gap-4 text-sm text-[#595959]" data-id="element-256">
              <span data-id="element-257">📧 digipromarket3@gmail.com</span>
              <span data-id="element-258">📲 @digi.promarket</span>
            </div>
          </div>

          <div className="border-t border-[#E8F5ED] pt-6 text-center text-sm text-[#595959]" data-id="element-259">
            <p className="mb-2" data-id="element-260">
              © Adelgaza con Air Fryer™ 2025 — Todos los derechos reservados.
            </p>
            <p className="mb-4" data-id="element-261">
              Infoproducto digital en PDF. No es un servicio médico ni
              nutricional. Los resultados pueden variar.
            </p>
            <p className="text-lg text-[#666666] italic" data-id="element-262">
              🍗 "La próxima cena puede ser el inicio de tu cambio."
            </p>
          </div>
        </div>
      </footer>
    </div>;
}